import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import NoPeanutPolicyFormComp from '../../../../components/registrationPacket/NoPeanutPolicyFormComp';

const NoPeanutPolicyForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = Boolean(id);

  useEffect(() => {
   
  }, []);

  return (
    <Container>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title">
                  {isEditMode ? 'Edit' : 'Sign'} No Peanut Policy
                </h4>
              </div>
              <Button variant="secondary" size="sm" onClick={() => navigate('/dashboard/no-peanut-policy/list')}>
                <i className="icon material-symbols-outlined me-1" style={{verticalAlign: 'middle'}}>arrow_back</i>
                Back to List
              </Button>
            </Card.Header>
            <Card.Body>
              <NoPeanutPolicyFormComp isEditMode={isEditMode} existingData={""}/>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default NoPeanutPolicyForm;
